import clsx from 'clsx';
import styles from './inline-notification-center-icon.module.scss';
import { IInlineNotification, InlineNotification } from '@sanlam-glacier/app-common/components';

interface InlineNotificationCenterIconProps extends IInlineNotification {
  centerAlignIcon?: boolean;
}

const InlineNotificationCenterIcon = (props: InlineNotificationCenterIconProps) => {
  return (
    <InlineNotification
      {...props}
      className={clsx(props.centerAlignIcon && styles.styleFixes, props.className)}
    />
  );
};

export default InlineNotificationCenterIcon;
